// @flow

import actions from '../actionCreators'
import update from 'immutability-helper';
import querystring from "querystring";
import FileUtils from "./FileUtils";

export let loadData = (searchValues: any) => {
    return (dispatch: any, getState: any) => {

        if(searchValues.isSubNavigation) {
            if(searchValues.archive.indexOf("/") != -1){
                searchValues.result_type = "show_content_only";
            }
        }

        switch (searchValues.result_type){
            case "show_all":
                searchValues.showImages = true;
                searchValues.showDocuments = true;
                searchValues.isContentOnly = false;
                break;
            case "show_content_only":
                searchValues.showImages = true;
                searchValues.showDocuments = true;
                searchValues.isContentOnly = true;
                break;
            case "show_images":
                searchValues.showImages = true;
                searchValues.showDocuments = false;
                searchValues.isContentOnly = true;
                break;
            case "show_documents":
                searchValues.showImages = false;
                searchValues.showDocuments = true;
                searchValues.isContentOnly = true;
                break;
        }

        dispatch(actions.requestSearch(searchValues));
        let searchUrl;
        switch (searchValues.searchType){
            case "norden":
                searchUrl = "/tam/norden-search?";
                break;
            case "saga":
                searchUrl = "/tam/saga-search?";
                break;
            default:
                searchUrl = "/tam/search?";
                break;
        }


        fetch(FileUtils.getAbsoluteUrl(searchUrl) + querystring.stringify(searchValues), {
            method: 'get'
        }).then((response) => response.json()).then(
            response => {
                dispatch(actions.receivedSearchResults(response));
            }
        ).catch(error => {
            dispatch(actions.receivedSearchError(error));
        })
    };
};

export let navigateToPage = (dispatch, getState, pageNumber: number) =>{
    let currentSearch = getState().searchResults.searchValues;
    let newSearch = update(currentSearch, {
        page: {$set: pageNumber}
    });
    dispatch(loadData(newSearch));
};

export let navigateToFirst = (screen="primary") =>{
    return (dispatch, getState) => {
        //navigate to page 1.
        navigateToPage(dispatch, getState, 1);
    }
};

export let navigateToPrevious = (screen="primary") =>{
    return (dispatch, getState) => {
        let pageNumber = Number(getState().searchResults.results.paging.currentPage) - 1;
        navigateToPage(dispatch, getState, pageNumber);
    }
};

export let navigateToNext = (screen="primary") =>{
    return (dispatch, getState) => {
        let pageNumber = Number(getState().searchResults.results.paging.currentPage) + 1;
        navigateToPage(dispatch, getState, pageNumber);
    }
};

export let navigateToLast = (screen="primary") =>{
    return (dispatch, getState) => {
        let pageNumber = Number(getState().searchResults.results.paging.totalPages);
        navigateToPage(dispatch, getState, pageNumber);
    }
};

export let navigateToContents = (archiveRef: string="primary") => {
    return (dispatch, getState) => {
        let currentSearch = getState().searchResults.searchValues;

        let newSearch = update(currentSearch, {
            archive: {$set: archiveRef},
            page: {
                $set: 1
            },
            isSubNavigation: {$set: true}
        });
        dispatch(loadData(newSearch));
    }
};



// WEBPACK FOOTER //
// ./src/utils/operations.js